/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Box } from 'rebass'

export default props =>
    <Box
        {...props}
        sx={{
            py: 5,
        }}
    />
